<template>
    <div>
        <div class="product-small" v-if="preview">
            <v-img :src="logo" />
        </div>
        <div class="product-full" v-if="!preview">
            <v-card>
                <v-card-text>
                    <div class="d-flex align-center mb-5">
                        <h1>Bounces</h1>
                        <div style="max-width:200px;margin-left:auto">
                            <v-img :src="logo" />
                        </div>
                    </div>
                    
                    <v-data-table :headers="header"
                                :items="data"
                                :loading="loading2"
                                :search="search"
                                class="elevation-1"
                                mobile-breakpoint="0">

                    <template v-slot:item="{ item }">
                        <tr>
                            <td class="font-weight-bold">{{ item.email }}</td>
                            <td>{{ item.occurences }}</td>
                            <td>
                                {{ item.type }}
                                <v-tooltip bottom max-width="450">
                                    <template v-slot:activator="{ on }">
                                        <v-icon size="20" class="ml-1" v-on="on">mdi-information-outline</v-icon>
                                    </template>
                                    <span>{{ item.message }}</span>
                                </v-tooltip>
                            </td>
                            <td>{{ moment(item.updated).format("DD.MM.YYYY HH:mm") }}</td>
                            <td>{{ moment(item.expires).format("DD.MM.YYYY HH:mm") }}</td>
                            <td>
                                <v-tooltip bottom max-width="450" v-if="item.sent">
                                    <template v-slot:activator="{ on }">
                                        <v-icon size="20" color="green" class="ml-1" v-on="on">mdi-check-bold</v-icon>
                                    </template>
                                    <span>{{ moment(item.sent).format("DD.MM.YYYY HH:mm") }}</span>
                                </v-tooltip>
                            </td>
                        </tr>
                    </template>
                    </v-data-table>
                </v-card-text>
            </v-card>
        </div>
    </div>
</template>

<script>
import ProductMixin from "@/mixins/Product";
import Logo from "@/assets/cleverreach.png";
import moment from "moment";

export default {
    data: () => ({
        header: [
            { text: "Email", value: "email", class: 'primary white--text font-weight-bold' },
            { text: "Occurences", value: "occurences", class: 'primary white--text' },
            { text: "Error", value: "type", class: 'primary white--text' },
            { text: "Updated", value: "updated", class: 'primary white--text' },
            { text: "Expires", value: "expires", class: 'primary white--text' },
            { text: "Report", value: "sent", class: 'primary white--text' },
        ],
        loading2: true,
        search: "",
        data: [],
        logo: Logo,
    }),
    mixins: [ProductMixin],
    created() {
        this.fetchBounces();
    },
    methods: {
        moment,
        async fetchBounces() {
            this.data = await this.action("get_bounces");
            this.loading2 = false;
        }
    }
}
</script>